import { Card } from '@/components/ui/card';
import StratificationsTable from './StratificationsTable';
import { DashboardAnalytics } from '@/services/dashboard.service';

const Stratifications = ({ data }: { data?: DashboardAnalytics }) => {
  return (
    <Card className="p-6 mb-8 space-y-8" aria-label="Stratifications">
      <h3
        className="text-lg font-semibold text-gray-900 mb-4"
        data-test-id="interest-rate-type-title"
      >
        Stratifications
      </h3>
      <StratificationsTable
        title="Sector Distribution"
        firstColumnHeader="Property Type"
        rows={data?.sector_distribution.rows || []}
        total={data?.sector_distribution.total}
      />

      <StratificationsTable
        title="Loan Status"
        firstColumnHeader="Loan Status"
        rows={data?.loan_status.rows || []}
        total={data?.loan_status.total}
      />

      <StratificationsTable
        title="Property Lifecycle Management"
        firstColumnHeader="Loan Type"
        rows={data?.property_lifecycle.rows || []}
        total={data?.property_lifecycle.total}
      />

      <StratificationsTable
        title="Loan Type"
        firstColumnHeader="Amortization Type"
        rows={data?.amortization_type.rows || []}
        total={data?.amortization_type.total}
      />

      <StratificationsTable
        title="Leverage Distribution"
        firstColumnHeader="Capital Stack Position"
        rows={data?.leverage_distribution.rows || []}
        total={data?.leverage_distribution.total}
      />

      <StratificationsTable
        title="Maturity Distribution"
        firstColumnHeader="Maturities"
        rows={data?.maturity_distribution.rows || []}
        total={data?.maturity_distribution.total}
      />

      <StratificationsTable
        title="Location Distribution"
        firstColumnHeader="State"
        rows={data?.location_distribution.rows || []}
        total={data?.location_distribution.total}
      />
    </Card>
  );
};

export default Stratifications;
